
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth,apikey } from '../../constants/api';
import {
    // DEVICE_SUMMARY_FETCH,
    // DEVICE_FETCH,
    // MACHINE_TYPE_FETCH,
    // CREATE_NEW_MACHINE,
    // UPDATE_DEVICE_PROFILE,
    // DEVICE_DETAIL_FETCH
} from '../actions';

import {
    // deviceSummarySuccess,
    // deviceSummaryFail,
    // deviceSuccess,
    // deviceFail,
    // machineTypeSuccess,
    // machineTypeFail,
    // createMachineSuccess,
    // createMachineFail,
    // deviceDetailFetchSuccess,
    // deviceDetailFetchFail
} from './actions';

// const deviceFetchAsync = async () =>
// 	 await API.get('/device',
// 	 {
//       headers : {
//         'Content-Type': 'application/json',
//       //   'userid': data.user_id,
//         'apikey': apikey
//       }
//     })
//
//         .then(data => data)
//         .catch(error => error);


//* Get Total Number Of Device
// function* deviceSummaryFetch({ payload }) {
//     try {
//         const deviceSummaryFetch = yield call(deviceFetchAsync);
//         if (deviceSummaryFetch.data.StatusCode === "0000") {
//             let itemCount =  deviceSummaryFetch.data.ResultValues.length
//             yield put(deviceSummarySuccess(itemCount));
//         } else {
//             yield put(deviceSummaryFail(deviceSummaryFetch.data.Message));
//         }
//     } catch (error) {
//         yield put(deviceSummaryFail(error));
//     }
// }

// //* Get Device List
// function* deviceFetch({ payload }) {
//     try {
//         const deviceFetch = yield call(deviceFetchAsync);
//         if (deviceFetch.data.StatusCode === "0000") {
//             yield put(deviceSuccess(deviceFetch.data.ResultValues));
//         } else {
//             yield put(deviceFail(deviceSummaryFetch.data.Message));
//         }
//     } catch (error) {
//         yield put(deviceFail(error));
//     }
// }

// const machineTypeFetchAsync = async () =>
//     await API.get('/machine/machinetype',	 {
//       headers : {
//         'Content-Type': 'application/json',
//       //   'userid': data.user_id,
//         'apikey': apikey
//       }
//     })
//         .then(data => data)
//         .catch(error => error);

//* Get Machine Type
// function* machineTypeFetch({ payload }) {
//     try {
//         const machineTypeFetch = yield call(machineTypeFetchAsync);
//         if (machineTypeFetch.data.StatusCode === "0000") {
//             yield put(machineTypeSuccess(machineTypeFetch.data.ResultValues));
//         } else {
//             yield put(machineTypeFail(machineTypeFetch.data.Message));
//         }
//     } catch (error) {
//         yield put(machineTypeFail(error));
//     }
// }

//* Create New Machine
// const createMachineAsync = async (req) =>
//     await API.post('/machine/'+req.actionType, {
//       merchantId:req.merchantId,
//       machineId:req.machineId,
//       deviceId:req.deviceId,
//       machineName:req.machineName,
//       machineType:req.machineType,
//       machineTag:req.machineTag,
//       machineStatus:req.machineStatus,
//       createBy:req.createBy,
//       updateBy:req.updateBy,
//       machineSku:req.machineSku,
//       updateprofileType:req.updateprofileType
//     },
//     {
//       "headers" : auth
//     })
//         .then(data => data)
//         .catch(error => error);
//
//   function* createMachine({ payload }) {
//     const { machineCreate } = payload;
//     // console.log("machineCreate : ",machineCreate)
//       try {
//           const createMachine = yield call(createMachineAsync, machineCreate);
//           // console.log("saga createMachine : ",createMachine)
//           if (createMachine.data.StatusCode === "0000") {
//               yield put(createMachineSuccess(createMachine.data));
//           } else {
//               yield put(createMachineFail(createMachine.data.Message));
//           }
//       } catch (error) {
//           yield put(createMachineFail(error));
//       }
//   }
//
//   //* Update Profile To Mqtt
//   const updateDeviceProfileAsync = async (req) =>
//       await API.post('/device/mqtt/updateprofile', {
//         machineId:req.machineId
//       },
//       {
//         "headers" : auth
//       })
//           .then(data => data)
//           .catch(error => error);
//
//   function* updateDeviceProfile({ payload }) {
//     const { profile } = payload;
//       try {
//           const updateDeviceProfile = yield call(updateDeviceProfileAsync, profile);
//           if (updateDeviceProfile.data.StatusCode === "0000") {
//               yield put(createMachineSuccess(updateDeviceProfile.data));
//           } else {
//               yield put(createMachineFail(updateDeviceProfile.data.Message));
//           }
//       } catch (error) {
//           yield put(createMachineFail(error));
//       }
//   }
//
//   const deviceDetailFetchAsync = async (id) =>
//       await API.get('/device/'+id, {
//
//       },
//       {
//         "headers" : auth
//       })
//           .then(data => data)
//           .catch(error => error);
//
//     //* Get Device Detail
//     function* deviceDetailFetch({ payload }) {
//       const { deviceDetail } = payload;
//         try {
//             const deviceDetailFetch = yield call(deviceDetailFetchAsync,deviceDetail);
//             // console.log("deviceDetailFetch ", deviceDetailFetch)
//             if (deviceDetailFetch.data.StatusCode === "0000") {
//                 yield put(deviceDetailFetchSuccess(deviceDetailFetch.data.ResultValues));
//             } else {
//                 yield put(deviceDetailFetchFail(deviceDetailFetch.data.Message));
//             }
//         } catch (error) {
//             yield put(deviceDetailFetchFail(error));
//         }
//     }


export function* watchMemberGroupFetch() {
    // yield takeEvery(DEVICE_SUMMARY_FETCH, deviceSummaryFetch)
    // yield takeEvery(DEVICE_FETCH, deviceFetch)
    // yield takeEvery(MACHINE_TYPE_FETCH, machineTypeFetch)
    // yield takeEvery(CREATE_NEW_MACHINE, createMachine)
    // yield takeEvery(UPDATE_DEVICE_PROFILE, updateDeviceProfile)
    // yield takeEvery(DEVICE_DETAIL_FETCH, deviceDetailFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchMemberGroupFetch),
    ]);
}
